import {useContext} from "react";
import BillingContext from "../../../context/BillingContext";
import {Button} from "@mui/material";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import AuthContext from "../../../context/AuthContext";
import {hasPermission} from "../../../permissions/hasPermission";

const AddBillingButton = () => {
    const {setAddNewBillingDetail} = useContext(BillingContext)
    const {user} = useContext(AuthContext)
    const canEditSettings = hasPermission(user, 'settings', 'edit')
    return <Button disabled={!canEditSettings} onClick={() => setAddNewBillingDetail(true)} variant='contained' endIcon={<AddCircleRoundedIcon/>}>Új hozzáadása</Button>

}

export default AddBillingButton